import { render } from "./SupportArticleDialog.vue?vue&type=template&id=62235bc4&scoped=true"
import script from "./SupportArticleDialog.vue?vue&type=script&lang=js"
export * from "./SupportArticleDialog.vue?vue&type=script&lang=js"

import "./SupportArticleDialog.vue?vue&type=style&index=0&id=62235bc4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62235bc4"]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QVideo from 'quasar/src/components/video/QVideo.js';import ClosePopup from 'quasar/src/directives/close-popup/ClosePopup.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QCard,QBtn,QCardSection,QVideo});qInstall(script, 'directives', {ClosePopup});
